import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getAuthorizationHeader, http } from '../../config/http';
import { IconEdit, IconX, IconDeviceFloppy } from '@tabler/icons-react';
import { CurrencyInput } from '../../utils/CurrencyInput';

export default function EditItem({ isOpenEditItem, kategori, setIsEdit, closeModalEditItem, cabang, detailItem }) {
  const [jenisKategori, setJenisKategori] = useState([]);
  const [jenis_kategori_id, setJenisKategoriId] = useState('');
  const [berat, setBerat] = useState('');
  const [karat, setKarat] = useState('');
  const [nomor_rak, setNomorRak] = useState('');
  const [cabang_id, setCabangId] = useState('');
  const [harga_modal, setHargaModal] = useState('');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpenEditItem) {
      setJenisKategoriId(detailItem.jenis_kategori_id);
      setBerat(detailItem.berat);
      setKarat(detailItem.karat);
      setCabangId(detailItem.cabang_id);
      setHargaModal(detailItem.harga_modal);
      setNomorRak(detailItem.nomor_rak);
    }
  }, [isOpenEditItem]);

  const [req, setReq] = useState({
    KategoriName: '',
    jenis_kategori_id: '',
  });

  const karatOption = [
    { karat: 16 }, { karat: 17 }, { karat: 18 }, { karat: 19 },
    { karat: 20 }, { karat: 21 }, { karat: 22 }, { karat: 23 }, { karat: 24 },
  ];

  const bakiOption = [
    { baki: 1 }, { baki: 2 }, { baki: 3 }, { baki: 4 }, { baki: 5 },
    { baki: 6 }, { baki: 7 }, { baki: 8 }, { baki: 9 }, { baki: 10 },
    { baki: 11 }, { baki: 12 }, { baki: 13 }, { baki: 14 }, { baki: 15 },
    { baki: 16 }, { baki: 17 }, { baki: 18 }, { baki: 19 }, { baki: 20 },
  ];

  async function SelectJenisKategori(e) {
    let name = e.target.name;
    let value = e.target.value;
    req[name] = value;
    let idData = value;
    await http
      .get(`/jenis/kategori/${idData}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setJenisKategori(res.data.data);

        return res.data.data;
      })
      .then((resId) => {
        setReq(resId);
      })
      .catch((err) => {
        console.log('error jenis kategori', err);
      });
  }

  // console.log({cabang_id, jenis_kategori_id, berat, karat, harga_modal, nomor_rak })

  async function handlesubmitUpdateItem(e) {
    // console.log("hallo")
    e.preventDefault();
    const data = { cabang_id, jenis_kategori_id, berat, karat, harga_modal, nomor_rak };
    // console.log('data::: ', data);
    setLoading(true);
    setIsEdit(true);
    try {
      const response = await http.put(`item/${detailItem.id}`, data, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      toast.success(response.data.message, { autoClose: 600, });
      // console.log(response)
      setLoading(false);
      closeModalEditItem();
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
    setIsEdit(false);
  }

  useEffect(() => {
    const regex = /^\d*\.?\d{0,3}$/;
    if (berat && !regex.test(berat)) {
      setBerat(berat.slice(0, -1));
    }
  }, [berat]);

  return (
    <>
      <Transition appear show={isOpenEditItem} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModalEditItem}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-[440px]">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-lg bg-white dark:bg-slate-900 text-left align-middle shadow-xl transition-all border dark:border-slate-800">
                  <div className="flex items-center justify-between px-4 py-3 sm:px-6 sm:py-4 border-b border-slate-200 dark:border-slate-700/60">
                    <div className="flex items-center gap-3">
                      <div className="hidden sm:flex items-center justify-center w-10 h-10 rounded-full bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400">
                        <IconEdit className="w-5 h-5" />
                      </div>
                      <div>
                        <Dialog.Title as="h3" className="text-base sm:text-lg font-semibold text-slate-900 dark:text-slate-100">
                          Edit Barang: {detailItem.jenis_kategori?.nama_jenis}
                        </Dialog.Title>
                        <p className="text-[10px] sm:text-xs text-slate-500 dark:text-slate-400 mt-0.5">Perbarui detail produk ini secara spesifik.</p>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={closeModalEditItem}
                      className="p-1.5 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300 transition-colors"
                      title="Tutup"
                    >
                      <IconX className="w-5 h-5" />
                    </button>
                  </div>

                  <div className="px-4 py-4 sm:px-6 sm:py-5">
                    <form>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div className="relative mt-3">
                          <select
                            id="kategori_name"
                            onChange={SelectJenisKategori}
                            name="KategoriName"
                            className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm text-slate-900 dark:text-slate-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer appearance-none transition-colors"
                            style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                          >
                            <option value="">Pilih Kategori</option>
                            {kategori.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nama_kategori}
                              </option>
                            ))}
                          </select>
                          <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-semibold text-slate-800 dark:text-slate-200">
                            Pilih Kategori <span className="text-amber-600 dark:text-amber-500 font-normal">({detailItem.jenis_kategori?.kategori?.nama_kategori})</span>
                          </label>
                        </div>
                        <div className="relative mt-3">
                          <select
                            id="jenis_kategori_id"
                            onChange={(e) => setJenisKategoriId(e.target.value)}
                            name="jenis_kategori_id"
                            className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm text-slate-900 dark:text-slate-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer appearance-none transition-colors"
                            style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                          >
                            <option value="">Pilih Jenis</option>
                            {jenisKategori.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nama_jenis}
                              </option>
                            ))}
                          </select>
                          <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-semibold text-slate-800 dark:text-slate-200">
                            Pilih Jenis <span className="text-amber-600 dark:text-amber-500 font-normal">({detailItem.jenis_kategori?.nama_jenis})</span>
                          </label>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                        <div className="mb-2">
                          <label htmlFor="berat" className="block mb-1.5 text-xs sm:text-sm font-semibold text-slate-800 dark:text-slate-200">
                            Berat (Gram)
                          </label>
                          <input
                            type="number"
                            id="berat"
                            name="berat"
                            autoComplete="off"
                            defaultValue={detailItem.berat || ''}
                            onChange={(e) => setBerat(e.target.value)}
                            className="w-full border rounded-md border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 px-3 py-3 sm:py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 transition-colors"
                          />
                        </div>
                        <div className="mb-2">
                          <label htmlFor="karat" className="block mb-1.5 text-xs sm:text-sm font-semibold text-slate-800 dark:text-slate-200">
                            Kadar (Karat)
                          </label>
                          <select
                            id="karat"
                            name="karat"
                            value={karat}
                            onChange={(e) => setKarat(Number(e.target.value))}
                            className="w-full border rounded-md border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 px-3 py-3 sm:py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 cursor-pointer transition-colors"
                            required
                          >
                            <option value="">Pilih Karat</option>
                            {karatOption.map((item) => (
                              <option key={item.karat} value={item.karat}>
                                {item.karat}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                        <div className="mb-2">
                          <label
                            htmlFor="nomor_rak"
                            className="block mb-1.5 text-xs sm:text-sm font-semibold text-slate-800 dark:text-slate-200"
                          >
                            Nomor BAKI
                          </label>
                          <select
                            id="nomor_rak"
                            name="nomor_rak"
                            value={nomor_rak}
                            onChange={(e) => setNomorRak(Number(e.target.value))}
                            className="w-full border rounded-md border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 px-3 py-3 sm:py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 cursor-pointer transition-colors"
                          >
                            <option value="">Pilih Baki</option>
                            {bakiOption.map((item) => (
                              <option key={item.baki} value={item.baki}>
                                {item.baki}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="mb-2">
                          <label
                            htmlFor="harga_modal"
                            className="block mb-1.5 text-xs sm:text-sm font-semibold text-slate-800 dark:text-slate-200"
                          >
                            Harga Modal / Gram
                          </label>
                          <CurrencyInput
                            name="harga_modal"
                            value={harga_modal}
                            autoComplete="off"
                            onChange={(value) => setHargaModal(value)}
                            className="w-full border rounded-md border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 px-3 py-3 sm:py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 transition-colors"
                            required
                          />
                        </div>
                      </div>

                      <div className="mb-4 mt-2">
                        <label
                          htmlFor="cabang_id"
                          className="block mb-1.5 text-xs sm:text-sm font-semibold text-slate-800 dark:text-slate-200"
                        >
                          Pilih Cabang / Titik Etalase <span className="text-amber-600 dark:text-amber-500 font-normal text-xs">(Saat ini: {detailItem.cabang?.nama_cabang})</span>
                        </label>
                        <select
                          id="cabang_id"
                          name="cabang_id"
                          value={cabang_id}
                          onChange={(e) => setCabangId(e.target.value)}
                          className="w-full border rounded-md border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 px-3 py-3 sm:py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 cursor-pointer transition-colors"
                        >
                          <option value="">Pilih Cabang / Titik Etalase</option>
                          {cabang.map((cb) => (
                            <option value={cb.id} key={cb.id}>
                              {cb.nama_cabang}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Footer */}
                      <div className="flex items-center justify-end gap-3 mt-6 pt-4 border-t border-slate-200 dark:border-slate-700/60">
                        <button
                          type="button"
                          onClick={closeModalEditItem}
                          className="px-4 py-2.5 sm:py-2 text-sm font-semibold bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 border border-slate-300 dark:border-slate-600 rounded-md transition-colors flex items-center gap-2"
                        >
                          <IconX className="w-4 h-4" />
                          Batal
                        </button>
                        {detailItem.is_ready && (
                          <button
                            type="button"
                            disabled={loading}
                            onClick={handlesubmitUpdateItem}
                            className={`px-5 py-2.5 sm:py-2 text-sm font-semibold text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 rounded-md shadow-sm transition-all flex items-center gap-2 disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed ${loading ? 'cursor-wait' : ''}`}
                          >
                            <IconDeviceFloppy className="w-4 h-4" />
                            {loading ? 'Proses..' : 'Simpan'}
                          </button>
                        )}
                      </div>
                    </form>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
